var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header"),
      _vm._v(" "),
      _c("div", { attrs: { id: "main" } }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _vm.project
                ? _c("h1", [_vm._v(_vm._s(_vm.project.Info.title))])
                : _vm._e(),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _vm.showMsg
                ? _c(
                    "div",
                    {
                      staticClass:
                        "alert alert-danger alert-dismissible fade show",
                      attrs: { role: "alert" }
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(_vm.msg) + "\n            "
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: {
                            type: "button",
                            "data-dismiss": "alert",
                            "aria-label": "Fechar"
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.hideMsg()
                            }
                          }
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×")
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPagarme
                ? _c("div", { staticClass: "payment-method row" }, [
                    _c("div", { staticClass: "method pagarme" }, [
                      _c(
                        "a",
                        {
                          attrs: { href: "" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.methodPagarme()
                            }
                          }
                        },
                        [_c("img", { attrs: { src: _vm.logoPagarme } })]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPagarme && _vm.hasPaypal
                ? _c("h5", [_vm._v("Ou")])
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPaypal
                ? _c("div", { staticClass: "payment-method row" }, [
                    _c("div", { staticClass: "method paypal" }, [
                      _c(
                        "a",
                        {
                          attrs: { id: "paypal-button", href: "" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.methodPaypal()
                            }
                          }
                        },
                        [_c("img", { attrs: { src: _vm.logoPaypal } })]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "form",
                      {
                        ref: "formPaypal",
                        attrs: {
                          action: "https://www.paypal.com/cgi-bin/webscr",
                          method: "post",
                          target: "_blank"
                        }
                      },
                      [
                        _vm.donation.type == "monthly"
                          ? _c("div", [
                              _c("input", {
                                attrs: {
                                  type: "hidden",
                                  name: "cmd",
                                  value: "_xclick-subscriptions"
                                }
                              }),
                              _vm._v(" "),
                              _c("input", {
                                attrs: { type: "hidden", name: "a3" },
                                domProps: {
                                  value: _vm.donation.value.toFixed(2)
                                }
                              }),
                              _vm._v(" "),
                              _c("input", {
                                attrs: {
                                  type: "hidden",
                                  name: "p3",
                                  value: "1"
                                }
                              }),
                              _vm._v(" "),
                              _c("input", {
                                attrs: {
                                  type: "hidden",
                                  name: "t3",
                                  value: "M"
                                }
                              }),
                              _vm._v(" "),
                              _c("input", {
                                attrs: {
                                  type: "hidden",
                                  name: "src",
                                  value: "1"
                                }
                              }),
                              _vm._v(" "),
                              _c("input", {
                                attrs: {
                                  type: "hidden",
                                  name: "sra",
                                  value: "1"
                                }
                              }),
                              _vm._v(" "),
                              _c("input", {
                                attrs: {
                                  type: "hidden",
                                  name: "no_note",
                                  value: "1"
                                }
                              })
                            ])
                          : _c("div", [
                              _c("input", {
                                attrs: {
                                  type: "hidden",
                                  name: "cmd",
                                  value: "_xclick"
                                }
                              }),
                              _vm._v(" "),
                              _c("input", {
                                attrs: {
                                  type: "hidden",
                                  name: "amount",
                                  id: "amountx"
                                },
                                domProps: {
                                  value: _vm.donation.value.toFixed(2)
                                }
                              })
                            ]),
                        _vm._v(" "),
                        _c("input", {
                          attrs: { type: "hidden", name: "business" },
                          domProps: { value: _vm.project.PaypalAccount.email }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          attrs: {
                            type: "hidden",
                            name: "no_shipping",
                            value: "1"
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          attrs: { type: "hidden", name: "item_name" },
                          domProps: {
                            value: "Doação para " + _vm.project.Info.title
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          attrs: { type: "hidden", name: "item_number" },
                          domProps: { value: _vm.donation.DonationId }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          attrs: {
                            type: "hidden",
                            name: "charset",
                            value: "utf-8"
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          attrs: {
                            type: "hidden",
                            name: "currency_code",
                            value: "BRL"
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          attrs: { type: "hidden", name: "return" },
                          domProps: {
                            value:
                              "https://click2giv.com/project/donation/finish/" +
                              _vm.donation.DonationId
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          attrs: { type: "hidden", name: "notify_url" },
                          domProps: {
                            value:
                              _vm.API.Projects.processNotificationPaypal +
                              _vm.donation.DonationId
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          attrs: { type: "hidden", name: "cancel_return" },
                          domProps: {
                            value:
                              "https://click2giv.com/project/donation/method/" +
                              _vm.donation.DonationId
                          }
                        })
                      ]
                    )
                  ])
                : _vm._e()
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("Footer"),
      _vm._v(" "),
      _vm.loading ? _c("Loading") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-tab" }, [
      _c("ul", [
        _c("li", [_vm._v("1 - Quanto quero doar")]),
        _vm._v(" "),
        _c("li", { staticClass: "active" }, [_vm._v("2 - Meios de pagamento")]),
        _vm._v(" "),
        _c("li", [_vm._v("3 - Compartilhar")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2296c87a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2296c87a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DonationMethod.vue
// module id = null
// module chunks = 